import filterAttached from "./filterAttached";
import filterWeight from "./filterWeight";

export default function(topology, minWeight, weight) {
  var a = filterAttached(topology),
      w = filterWeight(topology, minWeight, weight);
  return function(ring, interior) {
    return a(ring, interior) || w(ring, interior);
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/topojson/node_modules/topojson-simplify/src/filterAttachedWeight.js
// module id = 74
// module chunks = 0 1